<template>
  <div class="bg-b" id="content-ofer">
    <div class="hero">
      <div class="container">
        <el-row :gutter="20">
          <h1  class="pt-sans-bol sub-h1"> Subdirección Formación Docente Continua e Investigación </h1>
          <el-col :sm="15" :offset="0">
            
          <!-- <el-row> 
                <div  class="box2" style="float:left;  padding-left: 50px;" v-if="!$isMobile() ">
                  
                  <el-button type="default1" class="mt40" @click="$router.push({ name: 'normativa' })"
                    size="medium">Normativa</el-button>
                  <el-button type="primary" class="mt40" v-if="capas.length" @click="irCapas"
                    size="medium">Capacitaciones</el-button>
                </div>
           </el-row>
            -->   
          <el-row>
              <div  class="box2">
                <h3 class="pt-sans-bol" style="text-align: left;  font-size: 22px;"><strong>NUEVA METODOLOGÍA DE INSCRIPCIÓN:</strong></h3> <br>
                
                <p class="texto-con-interlineado">
                  Este sistema está basado en una Lista de espera. La PREINSCRIPCIÓN a una capacitación NO GARANTIZA su participación en la misma.

                 <br><br> Recuerde entrar periódicamente a su EFP para estar al tanto de sus capacitaciones y al estado actual de su preinscripción.
                  
                </p>

                <el-button type="default1" class="mt40" @click="$router.push({name: 'actualizacion'})" size="medium">Más Información</el-button>
                

                
              </div>
            </el-row>
            <br><br>
           <!--AQUI CALENDARIO-->
            <el-row>
              <el-col :span="24">
               

                <el-card class="box-card" style="padding: 10px;">

                  <h2 class="pt-sans-bol" style="background-color: #ded9f7; padding: 10px; border-radius: 8px; color: #4E33D6;">
                    <i class="el-icon-date" style="color: #4E33D6; margin-right: 5px;"></i>
                    Próximas Capacitaciones
                  </h2>
                  <br>
                  <div class="scroll-container" style="background-color: #DED9F7; padding: 10px; border-radius: 8px; max-height: 400px; overflow-y: auto;" v-if="capacitaciones.length >0">
                    <div class="capacitaciones-wrapper" >
                      <el-card v-for="cap in capacitaciones" :key="cap.id" class="cap-card" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
                        
                        <p class="cap-title" style="font-weight: bold;">{{ cap.nombre }}</p>
                        <p style="font-size: 14px;"><strong>Comisión:</strong> #{{ cap.comision_id }}</p>
                        <p class="cap-fecha">
                          <strong>Periodo Preinscripción:</strong> 
                          <span style="background-color: #9de579"> {{ formatDate(cap.fecha_apertura_preinscripcion) }} </span> / 
                          <span style="background-color: #f2c17d"> {{ formatDate(cap.fecha_cierre_preinscripcion) }} </span>
                        </p>
                        <p style="font-size: 14px; word-break: break-word; white-space: normal; overflow-wrap: anywhere;" ><i class="el-icon-place" style="color: blue;"></i>{{ cap.lugar }}</p>
                        <p style="font-size: 14px; word-break: break-word; white-space: normal; overflow-wrap: anywhere;"><i class="el-icon-school" style="color: blue;"></i>{{ cap.direccion_nombre }} </p>
                      </el-card>
                    </div> 
                    
                  </div> 
                  <div v-else>
                      <i class="icon-pushpin"></i> <p style="text-align: center; color: #4E33D6;">Por el momento no hay capacitaciones próximas disponibles.<br> ¡Pronto habrá novedades!</p>
                  </div> 
                </el-card>
              </el-col>
            </el-row>
          </el-col>
          <el-col :sm="9" :offset="0" style=" margin:0px auto;" v-if="!$isMobile() ">
            <Login />
          </el-col>
          
        </el-row>
      </div>



    </div>

    <div class="container">
      <el-row :gutter="100" v-if="false">


        <!-- <el-col :sm="8" :offset="0">
          <div class="box2">
            <h1 class="pt-sans-bol sub-h1">
              Subdirección Formación Docente Continua e Investigación
            </h1>
          </div>
        </el-col> -->
        <el-col :md="24" v-if="!$isMobile()">
          <div class="box3">
            <h3 class="pt-sans-bol">

              {{ textos.titulo }}

            </h3>
            <div v-html="textos.mensaje"></div>

            <el-button type="default1" class="mt40" @click="$router.push({ name: 'normativa' })"
              size="default">Normativa</el-button>
            <el-button type="primary" class="mt40" v-if="capas.length" @click="irCapas"
              size="default">Capacitaciones</el-button>
          </div>
        </el-col>
        <el-col :md="16" v-if="false">
          <Login />
        </el-col>

      </el-row>


    </div>
    <div v-if="capas.length">

      <div class="nor-h2" id="capas">
        <div class="container">
          <h2 class="pt-sans-bol ">
            <!-- <span class="el-icon-menu"></span> -->
            <span style="float:left"></span>
            LISTADO DE OFERTA DE TRAYECTOS FORMATIVOS

            <!-- <span class="el-icon-s-operation" style="float:right"></span> -->
          </h2>
        </div>

      </div>
      <div class="container">
        <div class="card-grid">
          <capaCard v-for="(card, index) in capas" :key="index" :card="card" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios"
import Login from '@/components/login'
import capaCard from '@/components/capa.vue'
var VueScrollTo = require('vue-scrollto');
var options = {
  container: '#content-ofer',
  easing: 'ease-in',
  lazy: true,
  offset: -60,
  force: true,
  cancelable: true,
  onStart: function (element) {
    // scrolling started
  },
  onDone: function (element) {
    // scrolling is done
  },
  onCancel: function () {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  components: { Login, capaCard },
  data() {
    return {
      capacitaciones: [],
      capas: [],
      textos: [],
      currentDate: new Date()
    }
  },
  created() {
    this.getCapas();
    this.getTextos();
    this.getCalendario();
  },

  methods: {
    formatDate(date) {
      if (!date) return "";
      
      const [fullDate, fullTime] = date.split(" ");
      const [year, month, day] = fullDate.split("-");
      const [hour, minute, second] = fullTime.split(":");

      return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    },

    getCalendario()
    {
      HTTP.get('/gestionCapas/calendario')
          .then(res => {
                  
                  this.capacitaciones = res.data;
                  console.log("this.capacitaciones: ",this.capacitaciones)
                 
          })
          .catch((e) => {})
      
    },
    getTextos() {
      HTTP.get('/textos/home')
        .then(res => {
          this.textos = res.data
          window.sessionStorage.setItem('textosSession', JSON.stringify(res.data))
        })
        .catch((e) => {

          if (e.response.status === 429) {

            this.textos = JSON.parse(window.sessionStorage.getItem('textosSession'))
            // return false
          }

        })
    },
    getCapas() {
      const baseURL = window.location.hostname === 'localhost' || window.location.hostname === 'paginatest.tucuman.edu.ar'
        ? '/capaTest/listado'
        : '/capa/listado';

      HTTP.get(baseURL)
        .then(res => {
          this.capas = res.data
          window.sessionStorage.setItem('capaSession', JSON.stringify(res.data))
        })
        .catch((e) => {

          if (e.response.status === 429) {
            this.$message({
              message: 'Precaución, demasiadas peticiones en poco tiempo sobrecargan el servidor',
              type: 'info',
              showClose: false,
              duration: 3000,
            });

            this.capa = JSON.parse(window.sessionStorage.getItem('capaSession'))
            // return false
          }

        })
    },

    irCapas() {
      VueScrollTo.scrollTo('#capas', 300, options)
    },
    verCapa(id) {
      this.$router.push({ name: 'prueba', params: { id } })
    }
  },
}
</script>
<style scoped>
/* Estilos del contenedor principal */
.box-card {
  padding: 20px;
  border-radius: 12px;
}

/* Contenedor con scroll horizontal */
.scroll-container {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
}

.capacitaciones-wrapper {
  display: flex;
  gap: 15px;
  flex-wrap: nowrap;
  align-items: stretch; /* que todos los cards se alineen en altura */
}

/* Estilos del card */
.cap-card {
  width: 450px;
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  padding: 15px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden; /* evita que sobresalga contenido */
}

/* Evitar que el texto sobresalga y permitir saltos de línea */
.cap-title, .cap-fecha {
  font-size: 14px;
  margin-bottom: 10px;
  word-wrap: break-word;
  white-space: normal;
  overflow: visible;
}


.fecha-preinscripcion {
  background-color: rgba(0, 165, 235, 0.2); /* Color celeste claro */
  padding: 3px 8px;
  display: inline-block; /* Para que solo ocupe el tamaño del texto */
  border-radius: 4px; /* Bordes redondeados */
}
</style>

<style>
.texto-con-interlineado {
  line-height: 1.5;
}
.hero-msg{
  padding:0px 20px;
  border-left:2px solid #ffffff5d;
  border-radius:0px;
  padding-left: 50px;
}

.hero-msg strong{
  font-size:22px;
  display: block;
  margin-bottom: 20px;
  text-align: left;
}
.hero {

  color: #FFF;

  font-family: 'Roboto', sans-serif;
  background: #4CAF50 url(@/assets/base4.png) !important;
  padding: 50px 30px;
  
  text-align: center;
}
.hero h1 {
  font-size: 32px;
  text-transform: uppercase;
  text-align: left;
  /* padding-left: 10px; */

}
.hero h3 {
  font-size: 32px;

}

.hero small {
  font-size: 18px;
  display: block;
  margin-top: 10px;

}

.hero p {
  text-align: left;
  font-size: 18px;
  /* padding: 20px; */
}
.box3 {
  margin-top: 20px;
  color: #FFF;

  font-family: 'Roboto', sans-serif;
  background: #4CAF50 url(@/assets/base4.png) !important;
  padding: 50px 30px;
  border-radius: 12px;
  text-align: center;
}

.box3 h3 {
  font-size: 32px;

}

.box3 small {
  font-size: 18px;
  display: block;
  margin-top: 10px;

}

.box3 p {
  text-align: left;
  font-size: 18px;
  padding: 20px;
}
</style>
<style lang="scss" scoped>
.box2 {
  margin-top: 80px;
  background: rgba(0, 0, 0, 0.05);
  padding: 20px 10px;
  border-radius: 12px;
}

.sub-h1 {
  color: white;
  font-size: 26px;

  text-align: center;
  text-transform: uppercase;

}

.sub-h1::before {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%);
}

.login {
  padding: 30px
}

.msg {
  text-align: center;
  font-size: 13px;
  bottom: 10px;
  position: absolute;
  color: red;
  left: 20px;
  // border:1px dashed #ddd;
  // padding:10px;
  // width: 50%;
  // background: #f1f1f1;
}

.fold h1 {
  color: #333;
  font-size: 32px;
  line-height: 1;
  margin: 0;
  text-align: center;
  margin: 0px;
  margin-top: 10%;
  // font-weight: normal;

}

.fold h1>small {
  font-size: 18px;
  display: block;
  font-weight: normal;
  padding: 20px;
  color: #636060;
}

.box img {
  position: absolute;
  height: 60px;
  bottom: 10px;
  left: auto;
  right: 10px;
}

.box {
  position: relative;
  margin: 80px auto;
  width: 100%;
  height: 350px;
  background: rgba(255, 255, 255, 1);
  border-radius: 0px;
  // padding: 20px;
  border-left: 8px solid #174263;
  border-top-right-radius: 0%;
}

.fold {

  padding: 50px;
  // position: absolute;


}

/*
  paper fold corner
*/

.box:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-style: solid;
  border-width: 0 30px 30px 0;
  border-color: #ddd #174263;
  transition: all ease .5s;
}

/*
  on li hover make paper fold larger
*/
.box:hover:before {
  border-width: 0 35px 35px 0;
  border-color: #eee #174263;
}



@keyframes background {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.mt40 {
  margin-top: 40px;
 
}

.nor-h2 {
  margin-top: 0px;
}

@media screen and (max-width:768px) {
  .mt40 {
    margin-top: 10px;
  }

  .nor-h2 {
    margin-top: 0px;
  
  }

  .box2 {
    margin-top: 0px;
    background: rgba(0, 0, 0, 0.05);
    padding: 20px 10px;
    border-radius: 12px;
  }

  .sub-h1 {
    font-size: 24px;
  }

  .box3 {
    margin-top: 0;
    color: #FFF;
    font-family: 'Roboto', sans-serif;
    background: #4CAF50 url(http://localhost:8080/img/base4.debb8da3.png) !important;
    padding: 10px;
    border-radius: 0;
    text-align: center;
  }

  .box3 h3 {
    font-size: 20px;
  }

  .box3 p {
    text-align: left;
    font-size: 16px;
    padding: 0px;
  }
}
</style>
<style>
@media screen and (max-width:768px) {
  .hero-msg {
      padding: 20px 0px;
      border-top: 2px solid #ffffff4d;
      border-left: none;
      border-radius: 0px;
      margin-top: 20px;
    }
  
    .hero-msg strong {
      font-size: 18px;
      display: block;
      margin-bottom: 20px;
      text-align: left;
    }
  
    .hero {
  
      color: #FFF;
  
      font-family: 'Roboto', sans-serif;
      background: #4CAF50 url(@/assets/base4.png) !important;
      padding: 20px;
  
      text-align: center;
    }
  
    .hero h1 {
      font-size: 21px;
      text-transform: uppercase;
      text-align: left;
  
    }
  
    .hero h3 {
      font-size: 32px;
  
    }
        .hero p {

          font-size: 16px;
    
        }
  
    .hero small {
      font-size: 18px;
      display: block;
      margin-top: 10px;
  
    }
  .box2 {
    margin-top: 0px;
    background: rgba(0, 0, 0, 0.05);
    padding: 20px 10px;
    border-radius: 12px;
  }

  .sub-h1 {
    font-size: 24px;
  }

  .box3 {
    margin-top: 0;
    color: #FFF;
    font-family: 'Roboto', sans-serif;
    background: #4CAF50 url(http://localhost:8080/img/base4.debb8da3.png) !important;
    padding: 10px;
    border-radius: 0;
    text-align: center;
  }

  .box3 h3 {
    font-size: 20px;
  }

  .box3 p {
    text-align: left;
    font-size: 16px;
    padding: 10px 0px;
  }
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
  padding: 16px;
}

.listado {
  margin-top: 0px;
  height: calc(100vh - 200px);
  overflow: overlay;
  scrollbar-gutter: auto;
  overflow-x: hidden;

  /* Oculta las flechas del scroll */

}
</style>